import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import LoaderBlock from '../loader/LoaderBlock';
import SingleOrder from './SingleOrder';
import DateFilter from '../../elements/DateFilter';

import Filters from './Filters';
import { allProductTypesAction, clearErrors } from '../../redux/actions/userActions';
import Loader from '../loader/loader';
import { CREATE_ORDER_RESET } from '../../redux/constants/orderConstants';



/*************  ✨ Windsurf Command 🌟  *************/
const DelayedRefunds = () => {



    const dispatch = useDispatch()
    const { productTypes } = useSelector(state => state.allProductTypes);


    const { loading,
        orders,
        totalPages,
    } = useSelector((state) => state.orders)

    const { user } = useSelector(state => state.verifyEmailStore);
    const { loading: orderLoading, error, message } = useSelector(state => state.order)




    const [page, setPage] = useState('1');
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');



    // Remove one quantity



    useEffect(() => {

        dispatch(allProductTypesAction())

    }, [dispatch])






    useEffect(() => {


        if (error) {
            dispatch(clearErrors())
        }

        if (message) {
            dispatch({ type: CREATE_ORDER_RESET })
        }

    }, [error, message, dispatch])





    return (
        <Fragment>
            {orderLoading && <Loader />}
            
            {/* Breadcrumb Header */}
            <div className="flex justify-between items-center bg-white p-[1vmax_2vmax] rounded-xl shadow-sm border border-gray-100 mb-[2vmax]">
                <div className="flex items-center gap-3">
                    <div className="w-[0.4vmax] h-[1.8vmax] bg-indigo-600 rounded-full"></div>
                    <h2 className='text-[1.4vmax] lg:text-[1.1vmax] font-bold text-gray-800 uppercase tracking-wider'>Delayed Refunds</h2>
                </div>
                <div className="flex items-center gap-3 text-[0.9vmax] font-medium">
                    <span className="text-gray-400">Dashboard</span>
                    <i className="fa-solid fa-chevron-right text-gray-300 text-[0.7vmax]"></i>
                    <span className='text-indigo-600'>Refund Management</span>
                </div>
            </div>

            <DateFilter
                dateFrom={dateFrom}
                setDateFrom={setDateFrom}
                dateTo={dateTo}
                setDateTo={setDateTo}
            />

            <section className="mt-[1vmax]" >
                <Filters page={page} setPage={setPage} dateFrom={dateFrom} dateTo={dateTo} />
                
                <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                    <div className="overflow-x-auto custom-scrollbar">
                        <table className="w-full text-left border-collapse min-w-[1000px]">
                            <thead className="bg-gray-50/50 border-b border-gray-100">
                                <tr>
                                    <th className="p-[1.2vmax_1.5vmax] text-[0.85vmax] font-bold text-gray-500 uppercase tracking-wider text-center">Order ID</th>
                                    <th className="p-[1.2vmax_1.5vmax] text-[0.85vmax] font-bold text-gray-500 uppercase tracking-wider">Product Details</th>
                                    {user?.role !== 'PM' && (
                                        <th className="p-[1.2vmax_1.5vmax] text-[0.85vmax] font-bold text-gray-500 uppercase tracking-wider text-center">Ordered By</th>
                                    )}
                                    <th className="p-[1.2vmax_1.5vmax] text-[0.85vmax] font-bold text-gray-500 uppercase tracking-wider text-center">Date</th>
                                    <th className="p-[1.2vmax_1.5vmax] text-[0.85vmax] font-bold text-gray-500 uppercase tracking-wider text-center">Delay</th>
                                    <th className="p-[1.2vmax_1.5vmax] text-[0.85vmax] font-bold text-gray-500 uppercase tracking-wider text-center">Status</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-50">
                                {loading ? (
                                    <tr>
                                        <td colSpan="6" className="p-10 text-center">
                                            <LoaderBlock />
                                        </td>
                                    </tr>
                                ) : orders?.length > 0 ? (
                                    orders.map((order) => (
                                        <SingleOrder 
                                            key={order.id} 
                                            order={order} 
                                            user={user} 
                                            productTypes={productTypes} 
                                        />
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="6" className="p-20 text-center">
                                            <div className="flex flex-col items-center gap-3">
                                                <div className="w-16 h-16 rounded-full bg-gray-50 flex items-center justify-center text-gray-300">
                                                    <i className="fa-solid fa-box-open text-2xl"></i>
                                                </div>
                                                <p className="text-[1.1vmax] font-bold text-gray-400">No delayed refunds found</p>
                                                <p className="text-[0.85vmax] text-gray-400">Try adjusting your filters to find what you're looking for.</p>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>

            {totalPages > 1 && (
                <div className="flex items-center justify-center gap-2 mt-12 pb-12">
                    <button
                        className={`w-10 h-10 rounded-xl flex items-center justify-center transition-all ${page === 1 ? 'text-gray-300 cursor-not-allowed' : 'text-gray-600 hover:bg-indigo-50 hover:text-indigo-600 active:scale-95 border border-gray-100'}`}
                        disabled={page === 1}
                        onClick={() => setPage(page - 1)}
                    >
                        <i className="fa-solid fa-chevron-left text-xs"></i>
                    </button>

                    <div className="flex items-center gap-2 px-2 py-1 bg-white rounded-2xl border border-gray-100 shadow-sm">
                        {(() => {
                            const pages = [];
                            const maxVisible = 2;

                            const addPage = (p) => {
                                pages.push(
                                    <button
                                        key={p}
                                        className={`min-w-[2.5rem] h-10 rounded-xl font-bold text-[0.9vmax] transition-all active:scale-95 ${page === p ? 'bg-indigo-600 text-white shadow-lg shadow-indigo-100' : 'text-gray-500 hover:bg-gray-50'}`}
                                        onClick={() => setPage(p)}
                                    >
                                        {p}
                                    </button>
                                );
                            };

                            addPage(1);

                            if (page > maxVisible + 2) {
                                pages.push(<span key="dots-left" className="text-gray-300 px-2 font-bold">...</span>);
                            }

                            for (
                                let p = Math.max(2, page - maxVisible);
                                p <= Math.min(totalPages - 1, page + maxVisible);
                                p++
                            ) {
                                addPage(p);
                            }

                            if (page < totalPages - (maxVisible + 1)) {
                                pages.push(<span key="dots-right" className="text-gray-300 px-2 font-bold">...</span>);
                            }

                            if (totalPages > 1) {
                                addPage(totalPages);
                            }

                            return pages;
                        })()}
                    </div>

                    <button
                        className={`w-10 h-10 rounded-xl flex items-center justify-center transition-all ${page === totalPages ? 'text-gray-300 cursor-not-allowed' : 'text-gray-600 hover:bg-indigo-50 hover:text-indigo-600 active:scale-95 border border-gray-100'}`}
                        disabled={page === totalPages}
                        onClick={() => setPage(page + 1)}
                    >
                        <i className="fa-solid fa-chevron-right text-xs"></i>
                    </button>
                </div>
            )}
        </Fragment>
    )
}

export default DelayedRefunds